
import * as $ from 'jquery';
import * as Utils from '../helpers/utils';
import { Config } from '../config';
import { Logger } from '../logger';

declare var window: any;
declare var hermes: any;

export class ContentLoader {
  private static DEFAULT_AJAX_TIMEOUT = 5000;
  private requestUrl;

  constructor(private config: Config) {
    this.buildRequestUrl();
  }

  /**
   * Build the request URL with the StarsCRM criteria.
   */
  buildRequestUrl() {
    const { endpoint, failover, params, bannerOptions, ...criteria } = this.config;
    this.requestUrl = `${endpoint}?${Utils.toQueryString({ ...criteria, ...params })}`;
  }

  /**
   * Get the request url
   */
  getRequestUrl() {
    return this.requestUrl;
  }

  /**
   * Request the content detail for a zone(s)
   * @param zones the location associated with the request content
   */
  getZoneContentDetailsByZoneId(zones: Array<string>, label?: string) {

    if (!zones || zones.length <= 0) {
      return;
    }

    const headers = this.getAuthHeaders();
    const url = `${this.getRequestUrl()}&zone=${zones.join(',')}${label ? `&label=${label}` : ''}`;

    const request = $.ajax({
      url, // '../assets/content.json',
      type: 'GET',
      dataType: 'json',
      headers,
      timeout: ContentLoader.DEFAULT_AJAX_TIMEOUT
    })
      .fail(this.handleError);


    return request;
  }

  /**
   * Retrieve the default
   * @param zone
   */
  getZoneDefaultPackage(zone: string) {
    let failoverUrl = this.config.failover;

    if (!failoverUrl || !zone) {
      return;
    }

    const request = $.ajax({
      url: `${this.config.failover}/${zone}.json`,
      type: 'GET',
      dataType: 'json',
      timeout: ContentLoader.DEFAULT_AJAX_TIMEOUT
    })
      .fail(this.handleError);

    return request;
  }

  /**
   * Fetch the markup from the content urls (packages)
   * @param contentUrls the urls from which to fetch the markup
   */
  getPackageMarkup(...packageUrls: Array<string>) {
    const requests = packageUrls.map(url => $.get(url));
    return $.when.apply(this, requests);
  }

  /**
   * Check cookie first for auth tokens; if not found check the query string; otherwise check the window.ps.adapt function
   */
  getAuthHeaders() {

    const SBTK = Utils.getCookie('SBTK');
    const SBSG = Utils.getCookie('SBSG');
    const WBID = Utils.getCookie('WBID');

    if (SBTK && SBSG && WBID) {
      return {
        SBTK,
        SBSG,
        WBID
      };
    } else {
      const tokens = this.getTokenValues(Utils.getQueryParams());
      if (!tokens) {
        if (window.ps && window.ps.adapt && window.ps.adapt.getAppRef && window.ps.adapt.getAppRef().getTokens) {
          return this.getTokenValues(window.ps.adapt.getAppRef().getTokens());
        }
      }
      return tokens;
    }
  }

  getTokenValues(tokens: any) {
    const { u, token, signature } = tokens;
    if (u && token && signature) {
      return {
        'SBTK': token,
        'SBSG': signature,
        'WBID': u
      };
    }
  }

  handleError(jqXHR: JQueryXHR, textStatus: string, errorThrown: string) {
    const status = jqXHR.status;

    if (status !== 404) { // 404 is expected behaviour when no content is available
      Logger.report(new Error(`${Logger.APP_NAME} - Critical Error requesting content from the service: ${errorThrown || textStatus} (Status Code ${status})`));
    }
  }

}



// WEBPACK FOOTER //
// ./src/services/content-loader.ts